import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BranchesShowComponent} from '../../views/setting/branches/branches-show/branches-show.component';
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {validate} from "codelyzer/walkerFactory/walkerFn";
import {ItemsGroup} from "../../views/setting/itemsGroups/itemsGroups";
import {User} from "../../model";
import {UserService} from "../../services/user.service";
import {Message} from "primeng/api";
import {Router} from "@angular/router";

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    providers: []
})
export class UserProfileComponent implements OnInit {
    id: string;
    public user: User;
    userData: any;
    public logs: Log[];
    oldPass: any;
    msgs: Message[] = [];
    @Input() rowId;
    @Input() refShow;
    modalRef: NgbModalRef;
    form: FormGroup;
    passwordPattern = new RegExp("^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$");

    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                private router: Router,
                private userService: UserService,
                public translate: TranslateService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            this.id = userdata.id;
            this.oldPass = userdata.password;
        }
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            oldPassword: new FormControl('', Validators.required),
            newPassword: new FormControl('', Validators.required),
            confirmPassword: new FormControl('', Validators.required)

        });
        /*   this.logService.getAll(this.rowId).subscribe(
             logs => {
               this.logs = logs;
             },
             err => {
               console.log(err);
             }

           );*/
    }

    checkPassword(Pass, confirmPass){
        if(confirmPass !== null && Pass !== null){
            if(confirmPass == Pass){
                if(!this.passwordPattern.test(Pass)) {
                    this.msgs = [];
                    this.msgs.push({
                        severity: 'error',
                        summary: '',
                        detail: this.translate.instant('password fields should have minimum 4 chars')
                    });
                    return false;
                }
                else
                    return true;
            }   
            else{
                this.msgs = [];
                this.msgs.push({
                    severity: 'error',
                    summary: '',
                    detail: this.translate.instant('The new passwords doesn\'t match')
                });
                return false;
            }
        }
        else{
            return true;
        }
    }


    onSubmit() {
        if (this.form.valid) {
            let user: User = new User();
            user.name = null;
            user.status = null;
            user.picture = null;
            user.password = this.form.controls['oldPassword'].value;
            user.newPassword = this.form.controls['newPassword'].value;
            let newPass = this.form.controls['newPassword'].value,
                confirmPass = this.form.controls['confirmPassword'].value,
                flag = this.checkPassword(newPass, confirmPass);

            if (flag) {
                if (this.id) {
                    user.id = this.id;
                    this.userService.checkPassword(user).subscribe(
                        ruser => {
                            this.msgs = [];
                            if (ruser.result) {
                                this.msgs.push({
                                    severity: 'success',
                                    summary: '',
                                    detail: this.translate.instant(ruser.message)
                                });
                            } else {
                                this.msgs.push({
                                    severity: 'error',
                                    summary: '',
                                    detail: this.translate.instant(ruser.message)
                                });
                            }
                            this.form.reset();
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                        }, error => {
                            console.log(error);
                        }
                    );
                } else {

                    console.log('You can\'t create new user form here')
                }
            }

        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: true});
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    close() {
        this.activeModal.dismiss('done');
    }

    restoreLog(log: Log) {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                console.log("before dismiss");
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open(this.refShow, options);
        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
        this.modalRef.componentInstance.oldData = log.old;
        this.modalRef.componentInstance.newData = log.new;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/user-profile/user-profile.component.ts